import { render, staticRenderFns } from "./WarningAnimationIcon.vue?vue&type=template&id=e86d33f6&scoped=true&"
var script = {}
import style0 from "./WarningAnimationIcon.vue?vue&type=style&index=0&id=e86d33f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86d33f6",
  null
  
)

export default component.exports